const ja = {
  meta: {
    home: { title: "ジェニファー・ロペス 伝記とタイムライン｜非公式 JLo トリビュート", description: "独立した多言語タイムラインで、ジェニファー・ロペスの人生、キャリア、音楽、映画、スタイル、文化的影響を紹介します。公式サイトではありません。" },
    timeline: { title: "ジェニファー・ロペス タイムライン｜非公式 JLo トリビュート", description: "ジェニファー・ロペスのキャリアと文化的影響を出典付きで辿る年表。独立トリビュート — 公式サイトではありません。" },
    music: { title: "ジェニファー・ロペスの音楽とアルバム｜非公式 JLo トリビュート", description: "ジェニファー・ロペスの音楽キャリアの主要な瞬間を厳選。独立トリビュート — 公式サイトではありません。" },
    film: { title: "ジェニファー・ロペスの映画｜非公式 JLo トリビュート", description: "ジェニファー・ロペスの映画キャリアの主要な瞬間を厳選。独立トリビュート — 公式サイトではありません。" },
    style: { title: "ジェニファー・ロペスのスタイルとファッション｜非公式 JLo トリビュート", description: "ファッションとレッドカーペットにおけるジェニファー・ロペスの影響。独立トリビュート — 公式サイトではありません。" },
    legacy: { title: "ジェニファー・ロペスの文化的影響とレガシー｜非公式 JLo トリビュート", description: "ジェニファー・ロペスが世代を象徴するアーティストである理由。独立トリビュート — 公式サイトではありません。" },
    about: { title: "このプロジェクトについて｜非公式 JLo トリビュート", description: "ジェニファー・ロペスのこの独立した多言語トリビュートと年表について。公式サイトではありません。" },
    disclaimer: { title: "免責事項｜非公式 JLo トリビュート", description: "独立トリビュートサイトの免責事項。ジェニファー・ロペスとの提携や承認はありません。公式サイトではありません。" },
    contact: { title: "お問い合わせ｜非公式 JLo トリビュート", description: "このジェニファー・ロペス・トリビュートを運営する独立チームへご連絡ください。公式サイトではありません。" },
    privacy: { title: "プライバシーポリシー｜非公式 JLo トリビュート", description: "この独立したジェニファー・ロペス・トリビュートサイトのプライバシーポリシー。公式サイトではありません。" },
  },
  ui: {
    skipToContent: "コンテンツへ移動",
    exploreTimeline: "タイムラインを見る",
    officialWebsite: "公式ウェブサイト",
    officialStore: "公式ストア",
    onTheJlo: "On The JLo",
    readMore: "もっと読む",
    readLess: "閉じる",
    opensNewTab: "（新しいタブで開きます）",
    backToTop: "トップへ戻る",
    selectLanguage: "言語を選択",
    language: "言語",
    source: "出典",
    nav: { home: "ホーム", timeline: "タイムライン", music: "音楽", film: "映画", style: "スタイル", legacy: "レガシー", about: "概要", disclaimer: "免責事項", contact: "お問い合わせ", privacy: "プライバシー" },
  },
  disclaimer: {
    bar: "独立トリビュートサイト — ジェニファー・ロペスや公式チームとの提携・承認はありません。",
    long: "本サイトは独立したトリビュート・情報サイトです。ジェニファー・ロペス、そのマネジメント、レコードレーベル、ブランド、公式ウェブサイト、公式ストアとの提携・承認・スポンサー・公式な関係はありません。",
  },
  hero: { title: "ジェニファー・ロペス:", titleAccent: "ブロンクスから世界的アイコンへ", subtitle: "ジェニファー・ロペスの人生、芸術性、キャリアの節目、文化的影響を探る、独立した多言語トリビュート。" },
  trust: { heading: "独立したトリビュート", body: "本サイトは独立したトリビュート・情報サイトです。ジェニファー・ロペス、そのマネジメント、レーベル、ブランド、公式サイト、公式ストアとの提携・承認・スポンサーはありません。公式情報は下記の公式リンクをご利用ください。" },
  timelineSection: { kicker: "ブロンクスから世界へ", heading: "人生とキャリアの年表", subtitle: "世界的キャリアを形づくった瞬間を辿る、時系列で出典付きの旅。" },
  categories: { earlyLife: "幼少期", music: "音楽", film: "映画", dance: "ダンス", fashion: "ファッション", business: "ビジネス", legacy: "レガシー" },
  pillarsSection: { kicker: "キャリアの柱", heading: "世界的キャリアを支える6つの柱", subtitle: "彼女の仕事が足跡を残した創造的・文化的領域。" },
  pillars: {
    music: { title: "音楽", body: "ダンスポップのデビューからチャート1位のアルバムまで、音楽は20年以上にわたり彼女の中心にあります。" },
    film: { title: "映画", body: "ロマンティック・コメディからドラマ、『Hustlers』など高評価の役柄まで広がる確かな映画キャリア。" },
    dance: { title: "ダンス", body: "まずダンサーとして訓練を受け、動きと振付は今もライブパフォーマンスの核心にあります。" },
    fashion: { title: "ファッションとスタイル", body: "レッドカーペットやステージでのスタイルは、ファッションと美をめぐる幅広い議論に影響を与えました。" },
    business: { title: "ビジネスとブランド", body: "フレグランスやライフスタイル事業へ拡大し、セレブリティ・ブランドのモデル形成に寄与しました。" },
    impact: { title: "文化的影響", body: "最も注目されるラテン系アーティストの一人として、主流ポップ文化における表象を広げました。" },
  },
  impactSection: {
    kicker: "世界的影響",
    heading: "世界規模の文化的足跡",
    subtitle: "一般的な文化的概観 — 誇張した数字は意図的に避けています。",
    points: [
      { title: "ラテン・ポップ文化", body: "ラテン・ポップの音やアーティストを世界の主流へさらに押し上げる助けとなりました。" },
      { title: "ハリウッドでの表象", body: "主役級の映画でラテン系演者の可視性を高めました。" },
      { title: "世界の音楽チャート", body: "複数のアルバムで国際的なチャート成功を収めました。" },
      { title: "ファッションと美", body: "レッドカーペットや美容で広く話題となる潮流に影響を与えました。" },
      { title: "ライブパフォーマンス", body: "大舞台でのエネルギッシュでダンス主体のライブで知られます。" },
      { title: "多文化のファン層", body: "多くの国で幅広く多言語のファン層を築きました。" },
    ],
  },
  worksSection: { kicker: "選りすぐりの作品", heading: "音楽と映画のハイライト", music: "音楽のハイライト", film: "映画のハイライト", whyItMatters: "重要な理由" },
  essay: {
    kicker: "エディトリアル",
    heading: "ジェニファー・ロペスはなぜ世代を象徴するアーティストの一人になったのか",
    paragraphs: [
      "音楽、映画、ダンスの間をこれほど自在に行き来したアーティストは多くありません。ニューヨークでダンサーとして出発し、一つの領域にとどまらないキャリアを築きました。",
      "『Selena』での飛躍とその直後のデビューアルバムは、映画と音楽の話題を同時に牽引するという稀有な能力を示しました。この多才さが彼女の代名詞となりました。",
      "作品そのものに加え、その可視性も重要でした。時代を代表するラテン系アーティストの一人として表象を広げ、主流ポップ文化の音・見え方・パフォーマンスの形成に寄与しました。",
    ],
    pullQuote: "ブロンクスから世界の舞台へ — 多才さ、規律、そして再創造に支えられたキャリア。",
  },
  faqSection: { kicker: "質問", heading: "よくある質問" },
  faq: {
    official: { q: "これはジェニファー・ロペスの公式サイトですか？", a: "いいえ。本サイトは独立したトリビュート・情報サイトです。ジェニファー・ロペスやそのチームとの提携はありません。" },
    "where-website": { q: "ジェニファー・ロペスの公式サイトはどこですか？", a: "「公式ウェブサイト」ボタンから公式サイトをご覧ください。" },
    "where-store": { q: "ジェニファー・ロペスの公式グッズはどこで買えますか？", a: "「公式ストア」ボタンをご利用ください。本サイトでは商品を販売していません。" },
    affiliated: { q: "このサイトはジェニファー・ロペスと提携していますか？", a: "いいえ。いかなる提携、スポンサー、承認もありません。" },
    about: { q: "このサイトは何についてですか？", a: "出典を明記しながら、ジェニファー・ロペスのキャリアと文化的影響を多言語の年表と紹介で提示します。" },
  },
  officialSection: {
    heading: "ジェニファー・ロペス公式リンク",
    subtitle: "公式情報をお探しですか？これらの外部リンクをご利用ください。",
    websiteDesc: "ジェニファー・ロペスの公式ウェブサイト。",
    storeDesc: "グッズの公式ストア。",
    onthejloDesc: "On The JLo からの公式ファン向け情報。",
    note: "公式リンクは新しいタブで開きます。これらのリンク先とは提携していません。",
  },
  footer: {
    tagline: "ジェニファー・ロペスの人生、キャリア、文化的影響に捧げる独立した多言語トリビュート。",
    notOfficial: "非公式 · 非提携 · 非承認。商品の販売はありません。",
    explore: "探す",
    official: "公式リンク",
    legal: "情報",
    copyright: "独立トリビュートサイト。すべての商標および名称は各権利者に帰属します。",
  },
  pages: {
    timeline: { intro: "音楽、映画、ダンス、文化における重要な瞬間を出典付きの年表で辿り、ブロンクスから世界的評価へ至るジェニファー・ロペスの歩みをご覧ください。" },
    music: { intro: "デビューから近作まで、ジェニファー・ロペスの音楽キャリアと厳選したアルバムのハイライトの概観。" },
    film: { intro: "『Selena』での飛躍から近年の主演まで、ジェニファー・ロペスの映画キャリアから厳選したハイライト。" },
    style: { intro: "レッドカーペットやステージでのジェニファー・ロペスの存在が、ファッションと美をめぐる幅広い議論とどう交わったか。" },
    legacy: { intro: "ジェニファー・ロペスの文化的影響と、なぜ世代を象徴するアーティストとされるのかを論じるエディトリアル。" },
    about: {
      heading: "このプロジェクトについて",
      paragraphs: [
        "本プロジェクトは独立したトリビュートであり文化的アーカイブです。ジェニファー・ロペスのキャリア、功績、文化的影響を明快な多言語形式で提示することを目的としています。",
        "公式サイトではなく、ジェニファー・ロペス、そのマネジメント、レーベル、ブランドとの関係はありません。公式情報はサイト内の公式リンクをご利用ください。",
        "内容は公開された信頼できる情報源に基づき、情報・教育目的で提供されます。権利者の方で訂正をご希望の場合はご連絡ください。",
      ],
    },
    disclaimer: {
      heading: "免責事項",
      intro: "この免責事項をよくお読みください。",
      points: [
        "これはジェニファー・ロペスの公式サイトではありません。",
        "ジェニファー・ロペスやそのチームとの提携・承認・スポンサーはありません。",
        "本サイトでは商品、チケット、グッズを販売していません。",
        "いかなる個人・団体のなりすましも意図していません。",
        "すべての商標、名称、関連権利は各権利者に帰属します。",
        "公式リンクは訪問者の利便のためにのみ提供しています。",
        "権利者の方で内容の訂正、クレジット、削除をご希望の場合はご連絡ください。",
      ],
    },
    contact: {
      heading: "お問い合わせ",
      intro: "このトリビュート・プロジェクトを運営する独立チームへは下記フォームからご連絡ください。",
      rightsHolderNote: "ジェニファー・ロペス、そのマネジメント、または権利者を代表する方で、内容の訂正・更新・クレジット・削除・リダイレクトをご希望の場合はご連絡ください。",
      form: { name: "お名前", email: "メール", reason: "ご用件", message: "メッセージ", submit: "送信する", sending: "送信中…", success: "ありがとうございます。メッセージを受け取りました。", error: "問題が発生しました。もう一度お試しください。" },
      reasons: { correction_request: "訂正のご依頼", translation_issue: "翻訳に関する問題", copyright_trademark_concern: "著作権・商標に関する懸念", general_feedback: "一般的なご意見" },
    },
    privacy: {
      heading: "プライバシーポリシー",
      paragraphs: [
        "この独立トリビュートサイトはあなたのプライバシーを尊重します。お問い合わせフォームで送信された情報など、あなたが提供を選んだ情報のみを収集します。",
        "アナリティクスが有効な場合、サイトの利用状況を把握するため匿名の利用データが収集されることがあります。運営者がキーを設定するまでアナリティクスは動作しません。",
        "お問い合わせフォームのデータはメッセージへの返信のみに使用し、マーケティング目的で販売・共有されることはありません。",
        "本サイトを利用することで本ポリシーに同意したものとみなされます。ご質問はお問い合わせページをご利用ください。",
      ],
    },
    notFound: { heading: "ページが見つかりません", body: "お探しのページは存在しないか、移動しました。", cta: "ホームへ戻る" },
  },
  timeline: {
    "birth-1969": { title: "ブロンクスで誕生", summary: "ジェニファー・リン・ロペスは1969年7月24日、ニューヨークのブロンクスでプエルトリコ系の両親のもとに生まれました。", details: "労働者階級のプエルトリコ系家庭で育ち、幼い頃から音楽とダンスに親しみました。" },
    "bronx-1970s": { title: "ニューヨークで成長", summary: "幼少期をブロンクスで過ごし、子どもの頃から歌とダンスを習いました。", details: "ニューヨークでの早い時期のパフォーマンス経験が、後のキャリアを支える規律を育みました。" },
    "dance-1980s": { title: "ダンサーとしての修練", summary: "10代でダンスに打ち込み、地域の公演やミュージックビデオで踊りました。", details: "ダンスに真剣に取り組み、バックダンサーやステージパフォーマーとして活動しました。" },
    "living-color-1991": { title: "In Living Color「Fly Girl」", summary: "番組『In Living Color』の「Fly Girl」ダンサーとして全国的な注目を集めました。", details: "この役が初の継続的なテレビ露出と、エンタメ業界への道をもたらしました。" },
    "acting-start-1995": { title: "初期の演技の役", summary: "『Mi Familia』や『Money Train』などの映画で演技に転じました。", details: "これらの初期の役が、ハリウッドで台頭する存在として彼女を確立しました。" },
    "selena-1997": { title: "『Selena』での飛躍", summary: "テハーノ歌手セレナ・キンタニージャを演じ、高い評価を得る飛躍となりました。", details: "主演により、当時最も注目されるラテン系俳優の一人となりました。" },
    "out-of-sight-1998": { title: "Out of Sight", summary: "スティーヴン・ソダーバーグの高評価の犯罪映画でジョージ・クルーニーと共演しました。", details: "この演技が、真摯な映画俳優としての評価を強めました。" },
    "on-the-6-1999": { title: "デビューアルバム『On the 6』", summary: "デビューアルバム『On the 6』で音楽キャリアを開始。タイトルはブロンクスの地下鉄路線に由来します。", details: "「If You Had My Love」などのシングルで、ポップ／ダンスのアーティストとして確立しました。" },
    "jlo-album-2001": { title: "『J.Lo』とグローバル・ブランド", summary: "アルバム『J.Lo』と「J.Lo」というペルソナが、多分野のグローバル・ブランドへの台頭を示しました。", details: "映画と音楽のチャートで同時に首位に立つことで知られるようになりました。" },
    "wedding-planner-2001": { title: "The Wedding Planner", summary: "ロマンティック・コメディの主演が、ジャンルの人気の一時代を形づくる助けとなりました。", details: "この作品で、興行を牽引する存在としての地位を固めました。" },
    "this-is-me-then-2002": { title: "『This Is Me... Then』", summary: "ヒット曲「Jenny from the Block」を収録し、ブロンクスの出自を強調しました。", details: "最も個人的で象徴的なアルバムの一つとなりました。" },
    "maid-in-manhattan-2002": { title: "Maid in Manhattan", summary: "主流映画でのスター性を確固たるものにした大ヒットのロマンティック・コメディ。", details: "この役は彼女の幅広い商業的魅力を際立たせました。" },
    "brand-fragrance-2005": { title: "フレグランスとビジネス", summary: "フレグランスやライフスタイル・ブランドへ拡大し、持続的な事業の存在感を築きました。", details: "その事業は美容におけるセレブ・ブランドのモデルを切り拓く助けとなりました。" },
    "american-idol-2011": { title: "American Idol 審査員", summary: "審査員として『American Idol』に参加し、巨大なテレビ視聴者に届きました。", details: "この役が米国全体での主流の可視性を広げました。" },
    "aka-2014": { title: "アルバム『A.K.A.』", summary: "音楽、映画、テレビのバランスを取りながら『A.K.A.』を発表しました。", details: "このアルバムはレコーディング・アーティストとしての継続的な進化を映しました。" },
    "hustlers-2019": { title: "『Hustlers』への称賛", summary: "『Hustlers』での役は、演技キャリアで最も高い評価のいくつかを獲得しました。", details: "この演技は広く称賛され、賞レースの議論を再燃させました。" },
    "super-bowl-2020": { title: "スーパーボウル・ハーフタイム", summary: "シャキーラとともにスーパーボウルLIVのハーフタイムショーを共同で務めました。", details: "このパフォーマンスは世界的観衆の前でラテン文化を称えました。" },
    "marry-me-2022": { title: "『Marry Me』", summary: "ミュージカル・ロマンティック・コメディ『Marry Me』に主演し、製作も担いました。", details: "本作は彼女の音楽と映画の仕事を一つの作品に結びつけました。" },
    "this-is-me-now-2024": { title: "『This Is Me... Now』", summary: "2002年のアルバムと対をなす『This Is Me... Now』を、映画的要素とともに発表しました。", details: "本作はキャリア初期のテーマを再び取り上げました。" },
    "atlas-2024": { title: "『Atlas』", summary: "SF映画『Atlas』に主演し、製作も担いました。", details: "この役は主演俳優兼製作者としての活動を継続するものでした。" },
  },
  discography: {
    "on-the-6": { title: "On the 6", why: "デビュー作が、信頼に足るポップ／ダンスのアーティストとして彼女を確立しました。" },
    jlo: { title: "J.Lo", why: "多分野のグローバル・ブランドへの台頭を固めました。" },
    "this-is-me-then": { title: "This Is Me... Then", why: "シングル「Jenny from the Block」が彼女の名声をブロンクスの出自と結びつけました。" },
    love: { title: "Love?", why: "ダンスフロア向けシングルに支えられたポップの復活を示しました。" },
    aka: { title: "A.K.A.", why: "レコーディング・アーティストとしての継続的な進化を示しました。" },
    "this-is-me-now": { title: "This Is Me... Now", why: "20年後に発表された内省的な対の作品。" },
  },
  filmography: {
    selena: { title: "Selena", why: "彼女を大きなスクリーンの才能として知らしめた決定的な主演。" },
    "out-of-sight": { title: "Out of Sight", why: "彼女のドラマの幅を証明した批評的称賛。" },
    "the-wedding-planner": { title: "The Wedding Planner", why: "ロマンティック・コメディの人気の一時代を形づくる助けに。" },
    "maid-in-manhattan": { title: "Maid in Manhattan", why: "主流のスター性を固めた興行ヒット。" },
    "monster-in-law": { title: "Monster-in-Law", why: "ベテラン共演者との商業的コメディの成功。" },
    hustlers: { title: "Hustlers", why: "キャリア屈指の名演と広く評価されています。" },
    "marry-me": { title: "Marry Me", why: "彼女の音楽と映画のアイデンティティを融合しました。" },
    "the-mother": { title: "The Mother", why: "大手ストリーミング・プラットフォームでの主演アクション。" },
    atlas: { title: "Atlas", why: "製作への意欲を映すSFの主演。" },
  },
};

export default ja;
